import { render } from "./NYFormView.vue?vue&type=template&id=b2448206&scoped=true"
import script from "./NYFormView.vue?vue&type=script&lang=js"
export * from "./NYFormView.vue?vue&type=script&lang=js"

import "./NYFormView.vue?vue&type=style&index=0&id=b2448206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2448206"]])

export default __exports__